<template>
  <BaseModal
    :size="modalSize"
    :use-portal="true"
    :title="modalTitle"
    v-on="$listeners"
  >
    <template v-slot:openBtn="{ openModal }">
      <div :class="criteriaTitle ? $style.calculatorIconVisibility : ``">
        <img
          :class="$style.calculatorIcon"
          src="@/assets/icons/ic_calculator.png"
          @click="
            () => {
              openModal();
            }
          "
        />
      </div>
    </template>
    <template v-slot:modalBody>
      <div>
        <div class="columns padding-top">
          <div class="column" :class="$style.alignlabel">
            <label :class="[$style.targetSampleSizeLable, 'label']"
              >Total Target</label
            >
          </div>
          <div class="column is-3">
            <bField :class="$style.inputContainer">
              <b-input
                v-model="calculateData.output"
                type="number"
                onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                @change.native="updateChildSamplingSize"
                placeholder="Enter Number"
              ></b-input>
            </bField>
          </div>
        </div>
        <template v-if="siteArray">
          <div
            class="columns padding-top"
            :class="$style.childSite"
            v-for="(siteValue, siteIndex) in siteArray"
          >
            <div class="column">
              <label :class="$style.label" class="label">{{
                siteValue.name
              }}</label>
            </div>
            <div class="column is-3">
              <bField :class="$style.inputTotalContainer">
                <b-input
                  :disabled="isDisableInput"
                  v-model="calculateData.sites[siteIndex].calculateData.output"
                  type="number"
                  onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                  @change.native="updateOtherChildSamplingSize(siteIndex)"
                  placeholder="Enter Number"
                ></b-input>
              </bField>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-slot:modalFoot="{ closeModal }">
      <button
        @click="handleApplySampleSize(closeModal)"
        class="button is-primary is-rounded"
        :class="$style.applyButton"
      >
        Apply
      </button>
    </template>
  </BaseModal>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseModal from '@/jbi-shared/vue-components/BaseModal.vue';
import { cloneDeep as _cloneDeep } from 'lodash';
import {
  AuditSamplingSite,
  CalculateData,
} from '@/store/modules/audits/types/audits.types';

@Component({
  components: {
    BaseModal,
  },
})
export default class ConsecutiveCalculator extends Vue {
  @Prop()
  public initialData!: any;
  @Prop()
  public siteArray!: AuditSamplingSite[];
  @Prop()
  public siteName!: string;
  @Prop()
  public criteriaTitle!: string;
  @Prop()
  public auditSiteId!: number;
  @Prop()
  public auditCriteriaId!: number;

  public modalTitle: string = 'Set Consecutive Sample Size';
  public modalSize: string = 'large';
  public calculateData: any = {
    output: 0,
  };
  public isCriteriaBasedMultiSiteSampling = false;
  public isDisableInput: boolean = true;

  public mounted() {
    if (this.initialData) {
      this.calculateData = _cloneDeep(this.initialData);
    }

    if (this.siteArray) {
      this.isCriteriaBasedMultiSiteSampling = true;
      this.updateChildSamplingSize();
    }
  }

  public handleCloseButton(closeModal: any) {
    closeModal();
  }

  public handleApplySampleSize(closeModal: any) {
    let emitData: any = this.calculateData;
    if (this.auditSiteId !== undefined) {
      emitData = {
        ...emitData,
        auditSiteId: this.auditSiteId,
      };
    }

    if (this.auditCriteriaId !== undefined) {
      emitData = {
        ...emitData,
        auditCriteriaId: this.auditCriteriaId,
      };
    }
    this.$emit('applySampleSize', emitData);
    closeModal();
  }

  public updateChildSamplingSize() {
    if (
      this.siteArray !== undefined &&
      this.calculateData.sites !== undefined
    ) {
      const parentVal = this.calculateData.output;
      const siteArrayLength = this.siteArray.length;
      const modulo = parentVal % siteArrayLength;
      const childVal = (parentVal - modulo) / siteArrayLength;
      this.calculateData.sites.forEach(
        (currentVal: AuditSamplingSite, siteIndex: number) => {
          currentVal.calculateData.output =
            siteIndex === 0 ? childVal + modulo : childVal;
        },
      );
    }
  }

  public updateOtherChildSamplingSize(siteIndex: number) {
    if (
      this.siteArray !== undefined &&
      this.calculateData.sites !== undefined
    ) {
      const currentElementVal = !this.calculateData.sites[siteIndex]
        .calculateData.output
        ? 0
        : Number(this.calculateData.sites[siteIndex].calculateData.output);
      const parentVal: number = !this.calculateData.output
        ? 0
        : Number(this.calculateData.output);
      if (parentVal < currentElementVal) {
        this.updateChildSamplingSize();
      } else {
        const tempParentVal = parentVal - currentElementVal;
        const siteArrayLength = Number(this.siteArray.length - 1);
        const modulo = tempParentVal % siteArrayLength;
        const childVal = (tempParentVal - modulo) / siteArrayLength;
        this.calculateData.sites.forEach(
          (currentVal: AuditSamplingSite, currentSiteIndex: number) => {
            if (currentSiteIndex !== siteIndex && siteIndex !== 0) {
              currentVal.calculateData.output =
                currentSiteIndex === 0 ? childVal + modulo : childVal;
            } else if (currentSiteIndex !== siteIndex) {
              currentVal.calculateData.output =
                currentSiteIndex === 1 ? childVal + modulo : childVal;
            }
          },
        );
      }
    }
  }

  @Watch('calculateData', { deep: true })
  public onCheckCalculateData(value: any) {
    if (value.sites) {
      this.isDisableInput = Number(value.output) !== 0 ? false : true;
    }
  }
}
</script>
<style lang="scss" module>
.bField .label {
  color: #9f9f9f;
  font-size: 14px;
}

.calculatorIcon {
  width: 16px;
  height: 20px;
  cursor: pointer;
  margin-left: 8px;
}
.inputContainer {
  position: relative;
  float: right;
  input {
    width: 80px;
    height: 44px;
    text-align: right;
  }
  .percentageContainer {
    position: absolute;
    right: 6px;
    font-size: 18px;
    top: 13px;
    z-index: 4;
  }
}
.inputTotalContainer {
  position: relative;
  float: right;
  input {
    width: 80px;
    height: 44px;
    background-color: white !important;
    border-color: #dfdfdf !important;
    color: #444f51 !important;
    padding: 7px 7px;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
    text-align: right;
  }
}
.borderBottom {
  border-bottom: 0.5px solid #dbdbdb;
}
.targetSampleSizeLable {
  color: #444f51;
  font-size: 16px;
  font-weight: bold;
}
.outputSubheading {
  font-size: 14px;
}
.outputSubHeadingDisaplay {
  font-weight: bold;
}
.childSite {
  padding-left: 16px;
}
.label {
  font-size: 16px;
}
.subtitle {
  color: #444f51;
  font-size: 16px;
  font-weight: initial;
  padding-top: 8px;
}
.alignlabel {
  label {
    padding-top: 13px;
  }
}
.applyButton {
  width: 100px !important;
  height: 48px !important;
}
</style>
